import { useEffect } from 'react'
import '@/style/cooperationCase.scss'
import PageHero from '@/components/PageHero'
import Reveal from '@/components/Reveal'
import heroImg from '@/images/site/hero-case.jpg'

const CLIENTS = [
  { icon: require('@/images/cooperationCase/Goldwind.jpg'), name: 'Goldwind 金风科技' },
  { icon: require('@/images/cooperationCase/传麒科技（北京）股份有限公司.png'), name: '传麒科技' },
  { icon: require('@/images/cooperationCase/卧龙.jpg'), name: '卧龙集团' },
  { icon: require('@/images/cooperationCase/卧龙防爆.png'), name: '卧龙防爆' },
  { icon: require('@/images/cooperationCase/合康新能.png'), name: '合康新能' },
  { icon: require('@/images/cooperationCase/四方.png'), name: '四方继保' },
  { icon: require('@/images/cooperationCase/天诚同创.jpg'), name: '天诚同创' },
  { icon: require('@/images/cooperationCase/欧伏电气股份有限公司.png'), name: '欧伏电气' },
  { icon: require('@/images/cooperationCase/沧州惠邦.jpg'), name: '沧州惠邦' },
  { icon: require('@/images/cooperationCase/荣信兴业.png'), name: '荣信兴业' },
  { icon: require('@/images/cooperationCase/费莱科技.jpg'), name: '费莱科技' },
  { icon: require('@/images/cooperationCase/远大.png'), name: '远大' },
]

function CooperationCase() {
  useEffect(() => {
    const type = new URLSearchParams(window.location.search).get('type')
    if (!type) return
    const el = document.getElementById(type)
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  return (
    <>
      <PageHero
        eyebrow="Partners"
        title="合作案例"
        image={heroImg}
        stat={[{ value: '12', label: '合作客户' }]}
      />

      <section className="section case__section" id="cooperationCase">
        <div className="mainContent">
          <Reveal className="secHead center">
            <p className="secHead__eyebrow">Clients</p>
            <h2 className="secHead__title">合作客户</h2>
          </Reveal>

          <div className="case__grid">
            {CLIENTS.map((client, i) => (
              <Reveal key={client.name} delay={(i % 4) * 70}>
                <div className="caseCard">
                  <div className="caseCard__media">
                    <img src={client.icon} alt={client.name} loading="lazy" />
                  </div>
                  <p className="caseCard__name">{client.name}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

    </>
  )
}

export default CooperationCase